/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useContext } from "react";
import { StyleSheet } from "react-native";
import { useTheme } from "../../../../providers/theme";
import { TextVW } from "@vlinder-web/text-vfw-widget-react";
//import blueprint from '../config/default-blueprint.json';
import { ScreenWidth } from "react-native-elements/dist/helpers";

//const BP = blueprint.ProvStepTitle;
const is = require("is_js");

interface IProvStepTitle {
  title?: string;
}

export const ProvenanceStepSubtitle = ({ title }: IProvStepTitle) => {
  const theme = useTheme();
  const _renderTitle = () => {
    if (title && typeof title === "string" && is.not.empty(title)) {
      return (
        <TextVW
          type={"subhead"}
          numberOfLines={2}
          ellipsizeMode={"tail"}
          children={title}
          align={"center"}
          style={StyleSheet.flatten([styles.titleStyle])}
          color={theme?.colors?.primary}
        />
      );
    }
  };

  return <>{_renderTitle()}</>;
};

const styles = StyleSheet.create({
  titleStyle: {
    alignSelf: "center",
    marginTop: "1%",
    marginBottom: "1%",
    fontSize: 14,
    letterSpacing: 1,
    width: ScreenWidth * 0.7,
  },
});

ProvenanceStepSubtitle.defaultProps = {
  //title: BP.title,
} as Partial<IProvStepTitle>;
